import Avatar from '@anm/components/Avatar';
import TitleBlock from '@anm/components/TitleBlock';
import { FC } from 'react';
import styled from 'styled-components';

export type TeamInfoProps = { preview: string; title?: string };

const TitleBlockWrapper = styled(TitleBlock)`
  width: auto;
`;
const AvatarWrapper = styled(Avatar)`
  margin-right: 30px;
`;
const Wrapper = styled.div`
  display: flex;
  margin-top: 30px;
  align-items: flex-start;
`;

const TeamInfo: FC<TeamInfoProps> = ({ title, preview }) => (
  <Wrapper>
    <AvatarWrapper src={preview} size={100} />
    {title && <TitleBlockWrapper title={title} size="medium" />}
  </Wrapper>
);

export default TeamInfo;
